export default "__VITE_ASSET__104d6ca2__"